<template>
  <AppSection>
    <AppStrip class="strip">
      <AppContainer>
        <h3 class="mb-0">
          <div class="stars me-1">
            <StarIcon v-for="_ in (mobile ? 5 : 1)" />
          </div>
          <span>{{ $tt('page.more_reviews.body') }}</span>
          <span>
            <template v-for="(url, key, i) in links">
              <a :href="url" target="_blank" class="ms-1 white">
                {{ $tt(`socials.${key}`) }}
              </a>
              <template v-if="i < objectKeys(links).length - 1">, </template>
            </template>
          </span>
          <DesktopOnly tag="span" class="ms-1">
            <StarIcon />
          </DesktopOnly>
        </h3>
      </AppContainer>
    </AppStrip>
  </AppSection>
</template>

<script setup lang="ts">
import { objectKeys } from '~/helpers/general';
import type { ReviewLinks } from '~/types';

defineProps<{
  links: ReviewLinks;
}>();

const { mobile } = useBreakpoints();
</script>

<style scoped lang="scss">
.strip {
  padding: var(--space-8) 0;
}
h3 {
  font-weight: 400;
  display: inline;
}
a {
  font-weight: 500;
}
.stars {
  display: inline;
  align-items: center;
}

@media (max-width: 850px) {
  section {
    padding-bottom: var(--space-8) !important;
  }
  .strip {
    padding: var(--space-8) 0;
  }
  h3 {
    font-size: 24px;
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
  }
  .stars {
    display: flex;
    justify-content: center;
    gap: var(--space-3);
  }
}
</style>